import { Injectable, inject } from '@angular/core';
import { GoogleTrackingService } from '../google-tracking.service';
@Injectable({
    providedIn: 'root',
})
export class ProductRegistrationTrackingService {
    private readonly _googleTrackingService = inject(GoogleTrackingService);

    public trackProductRegistration(): void {
        this._googleTrackingService.track({
            event: 'formSubmit',
            formtype: 'Produktregistrierung',
        });
    }
}
